module.exports = __webpack_public_path__ + "img/icon-notebook-gray-with-shield.837155d6.svg";